import { HttpParams } from '@angular/common/http'
import { BaseWithId, PaginatedList, PaginatedSearchCriteria } from './base.model'

export class TimesheetProject extends BaseWithId {
    name!: string
    clientName!: string
    clientId!: number
    toInvoice!: boolean
    sendToCustomer!: boolean
    detailedTimesheet!: boolean
    showPriority!: boolean
    mapping?: TimesheetProjectMapping
    combinedClientWithProjectName!: string

    static fromJSON(json: any): TimesheetProject {
        const result: TimesheetProject = Object.create(TimesheetProject.prototype)

        return {
            ...result,
            ...json,
            mapping: json.mapping ? TimesheetProjectMapping.fromJSON(json.mapping) : undefined,
            combinedClientWithProjectName: `${json.clientName} - ${json.name}`
        }
    }
}

export class TimesheetProjectSearchCriteria extends PaginatedSearchCriteria {
    name?: string
    clientId?: number
    includeArchived?: boolean

    constructor(page?: number, pageSize?: number, name?: string, clientId?: number, includeArchived?: boolean) {
        super(page, pageSize)
        this.name = name
        this.clientId = clientId
        this.includeArchived = includeArchived
    }

    httpParams(): HttpParams {
        let params = super.httpParams()
        if (this.name) {
            params = params.set('name', this.name)
        }
        if (this.clientId) {
            params = params.set('clientId', `${this.clientId}`)
        }
        if (this.includeArchived) {
            params = params.set('includeArchived', `${this.includeArchived}`)
        }

        return params
    }
}

export class TimesheetProjectPaginatedList extends PaginatedList<TimesheetProject> {
    static fromJSON(json: any): TimesheetProjectPaginatedList {
        const result: TimesheetProjectPaginatedList = Object.create(TimesheetProjectPaginatedList.prototype)

        return {
            ...result,
            ...json,
            items: json.items ? json.items.map((item: any) => TimesheetProject.fromJSON(item)) : null
        }
    }
}

export class TimesheetProjectMapping extends BaseWithId {
    projectKey?: string
    invoiceId?: string
    versionId?: string
    issueKey?: string

    static fromJSON(json: any): TimesheetProjectMapping {
        const result: TimesheetProjectMapping = Object.create(TimesheetProjectMapping.prototype)

        return { ...result, ...json }
    }
}
